import { render, staticRenderFns } from "./MainOrderLine.vue?vue&type=template&id=23c68b28&scoped=true&"
import script from "./MainOrderLine.vue?vue&type=script&lang=js&"
export * from "./MainOrderLine.vue?vue&type=script&lang=js&"
import style0 from "./MainOrderLine.vue?vue&type=style&index=0&id=23c68b28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c68b28",
  null
  
)

export default component.exports